export const START_DATE_TRIGGERED_COMMUNICATION_TYPES: Record<
  string,
  StartDateTriggeredCommunicationType
> = Object.freeze({
  SURVEY: 'survey',
  MESSAGE: 'message',
  ALERT: 'alert',
});
